import {Fonts} from "@/constants/font";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import PlayerStore from "@/store/player";
import {NewsPanel} from "@/scenes.ui/news-panel";
import {Tr} from "@/i18n/i18n";
import CU from "@/utils/c-u";

export class ManualLink extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement, x: number, y: number, manualId: string, linkText: string,
                color: string = '#D0D0D0', isLongManual: boolean = false) {
        super(scene);

        this.scene = scene;
        this.x = x * CU.S;
        this.y = y * CU.S;

        let link = new BBCodeText(scene, 0, 0, '[color=' + color + '][shadow][u]' + linkText + '[/u][/shadow][/color]', {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '12pt',
            shadow: {
                offsetX: -1,
                offsetY: 2,
                color: '#000000'
            },
            stroke: '#000000',
            align: 'center',
            wrap: {
                mode: 1,
                width: 420
            },
            underline: {
                color: color,
                thickness: 1,
                offset: 4
            }
        }).setScale(CU.S, CU.S);

        link.setOrigin(0.5);
        link.setInteractive().on('pointerup', () => {
            PlayerStore.getManual(manualId).then(man => {
                let stringsInManual = man.split('\n').length - 1;
                let ip: NewsPanel = new NewsPanel(scene, canvas, Tr('manual'), man, () => {
                    ip.close();
                }, false, isLongManual);
                ip.openAnimated();
            });
        });

        this.add(link);
    }

}
